module.exports = "<header id=\"static-header\"> <h1> <a href=\"/\"><onboard-logo width=\"160\"></onboard-logo></a> </h1> <nav-sales></nav-sales> </header>";